import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeviceCardComponent } from '../../../devices/components/device-card/device-card.component';
import { DeviceDetails } from '../../../devices/components/devices.models';
import { TranslateModule } from '@ngx-translate/core';
import { MtuReadInterval } from '../../../devices/constants/mtu.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeviceCardComponent, TranslateModule],
  styleUrls: ['./field-operations-side-panel.component.scss'],
  templateUrl: './field-operations-side-panel.component.html'
})
export class FieldOperationsSidePanelComponent {
  readonly basicData = input();
  readonly customerCardData = input();
  readonly isMap = input(false);
  readonly deviceCardData = input.required<readonly DeviceDetails[]>();

  protected readonly OneWayTxFreq = '1WayTxFreq';
  protected readonly TwoWayTxFreq = '2WayTxFreq';

  protected getAttr(device: DeviceDetails, name: string): string | null {
    return device?.deviceAttributes?.find(a => a.name === name)?.value ?? null;
  }

  protected getAttrOrDash(device: DeviceDetails, name: string): string {
    const val = this.getAttr(device, name);
    return val && val.length ? val : '-';
  }

  protected getReadIntervalText(device: DeviceDetails): string {
    const raw = this.getAttr(device, 'ReadIntervalMinutes');
    if (!raw) {
      return '-';
    }
    const minutes = Number(raw);
    const found = MtuReadInterval.find(item => item.value === minutes);
    return found?.text ?? '-';
  }
}
